/* eslint-disable */
import Cropper from 'cropperjs'
import Exif from 'exif-js'
import b64toBlob from 'b64-to-blob'

export default {
  initilize(opt) {
    let self = this;
    this.options = opt;
    //创建dom
    this.createElement();
    //初始化裁剪对象
    this.cropper = new Cropper(this.preview, {
      aspectRatio: opt.aspectRatio || 1,
      autoCropArea: opt.autoCropArea || 0.8,
      viewMode: 0,
      guides: opt.aspectRatio == 'Free' ? false : true,
      cropBoxResizable: opt.aspectRatio == 'Free' ? false : true,
      cropBoxMovable: opt.aspectRatio == 'Free' ? false : true,
      dragCrop: opt.aspectRatio == 'Free' ? false : true,
      background: false,
      checkOrientation: false,
      checkCrossOrigin: true,
      rotatable: true,
      scalable: true,
      zoomable: false,
      zoomOnWheel: false,
      center: false,
      dragMode: 'none',
      toggleDragModeOnDblclick: false,
      compressLimit: 0,
      onUpload: null,
      onCropStart: null,
      ready: function () {
        if (opt.aspectRatio == 'Free') {
          let cropBox = self.cropper.cropBox;
          cropBox.querySelector('span.cropper-view-box').style.outline = 'none';
          self.cropper.disable();
        }
      }
    });
  },
  createElement() {
    //初始化图片为空对象
    this.preview = null
    let str = '<div><img id="clip_image" src="originUrl"></div><button type="button" id="cancel_clip">取消</button><button type="button" id="clip_button">确定</button>';

    let body = document.getElementsByTagName('body')[0];
    this.reagion = document.createElement('div');
    this.reagion.id = 'clip_container';
    this.reagion.className = 'container';
    this.reagion.innerHTML = str;
    //添加创建好的DOM元素
    body.appendChild(this.reagion);
    this.preview = document.getElementById('clip_image');

    //绑定一些方法
    this.initFunction();
  },
  initFunction() {
    this.clickBtn = document.getElementById('clip_button');
    this.cancelBtn = document.getElementById('cancel_clip');
    // 确定事件
    this.addEvent(this.clickBtn, 'click', () => {
      this.crop();
    })
    // 取消事件
    this.addEvent(this.cancelBtn, 'click', () => {
      this.destoried();
    })
  },
  clip(file, opt) {
    let self = this;

    // 调用初始化方法
    this.initilize(opt);

    // 获取图片文件资源
    this.picValue = file.file;

    Exif.getData(file.file, function () {
      self.Orientation = Exif.getTag(file.file, 'Orientation');
      // console.log(self.Orientation)
    });

    this.preview.style.display = 'none'
    let image = new Image();
    image.src = file.content
    image.onload = function () {
      let b64Data = self.compress(image);
      let reg = new RegExp('^data:image/[a-z]+;base64,')
      b64Data = b64Data.replace(reg, '');
      let contentType = 'image/png';
      let blob = b64toBlob(b64Data, contentType);
      let blobUrl = URL.createObjectURL(blob);
      self.originUrl = blobUrl
      if (self.cropper) {
        self.cropper.replace(self.originUrl);
      }
      self.preview.style.display = 'block'
    }

    // // 调用方法转成url格式
    // this.originUrl = this.getObjectURL(this.picValue);

    // // 每次替换图片要重新得到新的url
    // if (this.cropper) {
    //   this.cropper.replace(this.originUrl);
    // }
  },
  // 图片转码方法
  getObjectURL(file) {
    let url = null;
    if (window.createObjectURL != undefined) { // basic
      url = window.createObjectURL(file);
    } else if (window.URL != undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    return url;
  },
  // 点击确定进行裁剪
  async crop() {
    let croppedCanvas;
    let roundedCanvas;

    if (this.options.onCropStart && this.options.onCropStart instanceof Function) {
      await this.options.onCropStart()
    }

    croppedCanvas = this.cropper.getCroppedCanvas();
    roundedCanvas = this.getRoundedCanvas(croppedCanvas);
    let imgData = roundedCanvas.toDataURL();

    if (this.options.onUpload && this.options.onUpload instanceof Function) {
      await this.options.onUpload(imgData)
      this.destoried();
    }
  },
  // 获取裁剪图片资源
  getRoundedCanvas(sourceCanvas) {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    let width = sourceCanvas.width;
    let height = sourceCanvas.height;
    // console.log('Canvas: w' + width + 'h' + height);

    canvas.width = width;
    canvas.height = height;

    context.imageSmoothingEnabled = true;
    context.drawImage(sourceCanvas, 0, 0, width, height);
    context.globalCompositeOperation = 'destination-in';
    context.beginPath();
    context.rect(0, 0, width, height);
    context.fill();

    return canvas;
  },
  // 销毁原来的对象
  destoried() {
    //移除事件
    this.removeEvent(this.clickBtn, 'click', null);
    this.removeEvent(this.cancelBtn, 'click', null);
    //移除裁剪框
    this.reagion.parentNode.removeChild(this.reagion);

    //销毁裁剪对象
    this.cropper.destroy();
    this.cropper = null;
  },
  rotateImg(img, direction, canvas) {
    //最小与最大旋转方向，图片旋转4次后回到原方向
    const min_step = 0;
    const max_step = 3;
    if (img == null) return;
    //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    let height = img.height;
    let width = img.width;
    let step = 2;
    if (step == null) {
      step = min_step;
    }
    if (direction == 'right') {
      step++;
      //旋转到原位置，即超过最大值
      step > max_step && (step = min_step);
    } else {
      step--;
      step < min_step && (step = max_step);
    }
    //旋转角度以弧度值为参数
    let degree = step * 90 * Math.PI / 180;
    let ctx = canvas.getContext('2d');
    switch (step) {
      case 0:
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0);
        break;
      case 1:
        canvas.width = height;
        canvas.height = width;
        ctx.rotate(degree);
        ctx.drawImage(img, 0, -height);
        break;
      case 2:
        canvas.width = width;
        canvas.height = height;
        ctx.rotate(degree);
        ctx.drawImage(img, -width, -height);
        break;
      case 3:
        canvas.width = height;
        canvas.height = width;
        ctx.rotate(degree);
        ctx.drawImage(img, -width, 0);
        break;
    }
  },
  // 图片压缩
  compress(img) {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
    //瓦片canvas
    let tCanvas = document.createElement("canvas");
    let tctx = tCanvas.getContext("2d");
    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;

    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    let ratio;
    if ((ratio = width * height / 4000000) > 1) {
      console.log("大于400万像素")
      ratio = Math.sqrt(ratio);
      width /= ratio;
      height /= ratio;
    } else {
      ratio = 1;
    }
    canvas.width = width;
    canvas.height = height;
    // 铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片像素大于100万则使用瓦片绘制
    let count;
    if ((count = width * height / 1000000) > 1) {
      count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
      // 计算每块瓦片的宽和高
      let nw = ~~(width / count);
      let nh = ~~(height / count);
      tCanvas.width = nw;
      tCanvas.height = nh;
      for (let i = 0; i < count; i++) {
        for (let j = 0; j < count; j++) {
          tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
          ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
        }
      }
    } else {
      ctx.drawImage(img, 0, 0, width, height);
    }
    //修复ios上传图片的时候 被旋转的问题
    if (this.Orientation != "" && this.Orientation != 1) {
      switch (this.Orientation) {
        case 6://需要顺时针（向左）90度旋转
          this.rotateImg(img, 'left', canvas);
          break;
        case 8://需要逆时针（向右）90度旋转
          this.rotateImg(img, 'right', canvas);
          break;
        case 3://需要180度旋转
          this.rotateImg(img, 'right', canvas);//转两次
          this.rotateImg(img, 'right', canvas);
          break;
      }
    }
    // 进行最小压缩
    let ndata = canvas.toDataURL('image/png', 0.8);
    // console.log('压缩前：' + initSize);
    // console.log('压缩后：' + ndata.length);
    // console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
  },
  addEvent(obj, type, fn) {
    if (obj.addEventListener) {
      obj.addEventListener(type, fn, false);
    } else {
      obj.attachEvent('on' + type, fn);
    }
  },
  removeEvent(obj, type, fn) {
    if (obj.removeEventListener) {
      obj.removeEventListener(type, fn, false);
    } else {
      obj.detachEvent('on' + type, fn);
    }
  }
}
